import { Box, Breadcrumbs, Link, MenuItem, TextField, useTheme } from '@mui/material';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import Grid from '@mui/system/Unstable_Grid';
import moment from 'moment';
import { DynamicCard, Table, WaitDialog } from '@components';
import { useModal } from 'mui-modal-provider';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
const GasCarteiraView = ({ $state, AuthorizationService, GasService, UIService }) => {
    const [formasPagamento, setFormasPagamento] = useState([]);
    const didMount = useRef(false);
    const theme = useTheme();
    const { showModal } = useModal();
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 1000
    });
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const [tecnicos, setTecnicos] = useState([]);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [refetching, setRefetching] = useState(false);
    const [data, setData] = useState();
    const [user, setUser] = useState($state.params.user);
    const [form, setForm] = useState($state.params.form);
    const [from, setFrom] = useState(() => {
        return $state.params.from ? moment($state.params.from) : moment().day(5).subtract(7, 'days');
    });
    const [to, setTo] = useState(() => {
        const data = $state.params.from ? moment($state.params.from) : moment();
        const proximaSexta = data.clone().day(4);
        if (proximaSexta.isBefore(data))
            proximaSexta.add(7, 'days');
        return proximaSexta;
    });
    const [totalProcessos, setTotalProcessos] = useState(0);
    const [totalEntregar, setTotalEntregar] = useState(0);
    const [totalNumerario, setTotalNumerario] = useState(0);
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 50
        },
        {
            accessorKey: 'Processo.numeroProcesso',
            header: 'Número Processo',
            size: 80
        },
        {
            accessorKey: 'Processo.numeroParceiro',
            header: 'Número Parceiro',
            size: 80
        },
        {
            accessorKey: 'Processo.agendamento.data',
            header: 'Data de Inspeção',
            size: 80,
            Cell: ({ cell }) => <span>{moment(cell.getValue()).format('DD/MM/YYYY')}</span>
        },
        {
            accessorKey: 'Processo.agendamento.hora',
            header: 'Hora',
            size: 50
        },
        {
            accessorKey: 'CoreListaRelatorioResposta.realizada',
            header: 'Realizada?',
            size: 50,
            Cell: ({ cell }) => (cell.getValue() ? <span>Sim</span> : <span>Não</span>)
        },
        {
            accessorKey: 'CoreListaRelatorioResposta.PagamentoForma.designacao',
            header: 'Forma Pagamento',
            size: 100
        },
        {
            accessorKey: 'Processo.total',
            header: 'Valor Processo (€)',
            Cell: ({ cell }) => <span>{(cell.getValue() ?? 0).toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
            muiTableHeadCellProps: {
                align: 'right'
            },
            muiTableBodyCellProps: {
                align: 'right'
            }
        },
        {
            accessorKey: 'CoreListaRelatorioResposta.pagamentoMontante',
            header: 'Valor Faturado (€)',
            Cell: ({ cell }) => <span>{(cell.getValue() ?? 0).toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
            muiTableHeadCellProps: {
                align: 'right'
            },
            muiTableBodyCellProps: {
                align: 'right'
            }
        }
    ], []);
    const calculateInterval = async (data) => {
        // Última sexta antes ou igual à data escolhida
        let ultimaSexta = data.clone().day(5);
        if (ultimaSexta.isAfter(data)) {
            ultimaSexta.subtract(7, 'days');
        }
        // Próxima sexta depois da data escolhida
        let proximaSexta = data.clone().day(5).add(7, 'days');
        setTo(proximaSexta);
        setFrom(ultimaSexta);
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            //const opt = await GasService.options();
            //setOptions(opt);
            const tec = await GasService.getTecnicosFuncionario();
            setTecnicos(tec);
            const formas = await GasService.getFormasPagamento();
            setFormasPagamento(formas);
        }
    };
    const fetchData = async () => {
        if (user) {
            try {
                let sorter = [];
                let filters = {};
                // Filtros proprios
                filters['Processo.agendamento.tecnicoId'] = `$eq:${user}`;
                if (form) {
                    filters['CoreListaRelatorioResposta.pagamentoFormaId'] = `$eq:${form}`;
                }
                filters['Processo.agendamento.data'] = `$btn:${from.format('YYYY-MM-DD')};${to.format('YYYY-MM-DD')}`;
                let aux = await GasService.findAll({
                    limit: 1000,
                    page: 1,
                    filter: filters,
                    sortBy: sorter
                });
                // Update URL
                $state.go($state.current.name, {
                    user: user,
                    form: form,
                    from: from.format('YYYY-MM-DD')
                }, {
                    notify: false,
                    reload: false,
                    location: 'replace',
                    inherit: true
                });
                let data = aux.data;
                // Remove duplicados
                data = data.filter((v, i, a) => a.findIndex(t => t.processoId === v.processoId) === i);
                aux.meta.totalItems = data.length;
                aux.data = data;
                // Cálculo totais
                let totProcessos = data.reduce((acc, cur) => acc + cur.Processo?.total, 0);
                let totEntregar = data.reduce((acc, cur) => acc + cur.CoreListaRelatorioResposta?.pagamentoMontante, 0);
                // Visualizar info de numerário
                let totNumerario = data.filter(r => r.CoreListaRelatorioResposta.pagamentoFormaId == 1).reduce((acc, cur) => acc + cur.CoreListaRelatorioResposta?.pagamentoMontante, 0);
                setTotalProcessos(totProcessos);
                setTotalEntregar(totEntregar);
                setTotalNumerario(totNumerario);
                setData(aux);
            }
            catch (e) { }
        }
        setRefetching(false);
    };
    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            initialFetch();
        }
    }, []);
    useEffect(() => {
        fetchData(); // roda quando dependências mudam
    }, [pagination, filter, sort, user, form, from]);
    const excelGen = async (id, array) => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        let filename = `gas-carteira-${from.format('YYYY-MM-DD')}-${to.format('YYYY-MM-DD')}.xlsx`;
        let sorter = [];
        sort.forEach(r => {
            sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
        });
        let filters = {};
        // Filtros proprios
        filters['Processo.agendamento.tecnicoId'] = `$eq:${user}`;
        if (form) {
            filters['CoreListaRelatorioResposta.pagamentoFormaId'] = `$eq:${form}`;
        }
        filters['Processo.agendamento.data'] = `$btn:${from.format('YYYY-MM-DD')};${to.format('YYYY-MM-DD')}`;
        try {
            let o = await GasService.export({
                columns: columns.map((r) => {
                    return {
                        accessorKey: r.exportKey ?? r.accessorKey,
                        header: r.header
                    };
                }),
                filter: filters,
                sortBy: sorter
            });
            if (o) {
                // Decode Base64 and convert to a Blob
                const binary = atob(o.$data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                // Create a Blob and save it as an Excel file
                const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        }
        catch (e) {
            console.log(e);
            if (e && e.data) {
                UIService.addToast(e.data.message);
            }
            else {
                UIService.addToast('Ocorreu um erro ao exportar dados!');
            }
        }
        wait.destroy();
    };
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Gás
          </Link>
          <Link underline='hover' color='text.primary'>
            Carteira
          </Link>
        </Breadcrumbs>
      </Box>

      <Grid container spacing={1}>
        <Grid xs={12} md={6}>
          <DynamicCard title='Filtros' sx={{ height: '100%' }} content={[
            {
                label: 'Técnico:',
                value: AuthorizationService.canPerform('gasFiltrarCarteira') ? (<TextField size='small' value={user} onChange={e => {
                        setUser(e.target.value);
                    }} fullWidth select>
                    <MenuItem value={undefined} disabled></MenuItem>
                    {tecnicos &&
                        tecnicos.map(x => (<MenuItem value={x.id} key={x.id}>
                          {x.name}
                        </MenuItem>))}
                  </TextField>) : (<span>{user ? tecnicos.find(x => x.id === user)?.name : '-'}</span>)
            },
            {
                label: 'Forma Pagamento:',
                value: (<TextField size='small' value={form} onChange={e => {
                        setForm(e.target.value);
                    }} fullWidth select>
                    <MenuItem value={undefined} disabled></MenuItem>
                    {formasPagamento &&
                        formasPagamento.map(x => (<MenuItem value={x.id} key={x.id}>
                          {x.designacao}
                        </MenuItem>))}
                  </TextField>)
            },
            {
                label: 'Período:',
                value: (<LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker label='' format='DD/MM/YYYY' value={from} onChange={value => {
                        calculateInterval(value);
                    }} slotProps={{
                        textField: {
                            variant: 'outlined',
                            name: 'data',
                            fullWidth: true,
                            size: 'small',
                            helperText: 'Escolha um dia para definir o período (O período é sempre de sexta a quinta, calculado automaticamente com base no dia escolhido).'
                        }
                    }}/>
                  </LocalizationProvider>)
                //`${from.format('YYYY-MM-DD')} - ${to.format('YYYY-MM-DD')}`
            }
        ]} loading={false}/>
        </Grid>
        <Grid xs={12} md={6}>
          <DynamicCard title='Carteira' sx={{ height: '100%' }} content={[
            {
                label: 'Total processos:',
                value: totalProcessos.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
            },
            {
                label: 'Total faturado:',
                value: totalEntregar.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
            },
            {
                label: 'Total numerário:',
                value: totalNumerario.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
            }
        ]} loading={false}/>
        </Grid>

        {user && (<Grid xs={12} md={12}>
            <Table storageKey={$state.current.name} data={data} columns={columns} initial={{
                sort: sort,
                filter: filter
            }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} onExport={() => {
                excelGen([], false);
            }}/>
          </Grid>)}
      </Grid>
    </Box>);
};
export default GasCarteiraView;
